import React, { useEffect, useRef } from "react";
import PropTypes from "prop-types";
import BtnGreen from "../BtnGreen";
import { useDispatch, useSelector } from "react-redux";
import { setCurrentStep, toggleSubmitted } from "@/store/slices/GlobalSlice";
import Slider from "react-slick";

const categoryItems = [
  {
    background: "bg-sgbc-orange-300",
  },
  {
    background: "bg-sgbc-green-200",
  },
  {
    background: "bg-sgbc-blue-400",
  },
];

const Categories = (props) => {
  const dispatch = useDispatch();
  const { mainCategories, isSubmitted } = useSelector(
    (state) => state.globalSlice
  );
  const sliderCateRef = useRef(null);

  const handleStepForm = () => {
    dispatch(setCurrentStep("upload"));
  };

  const settings = {
    dots: false,
    infinite: false,
    speed: 800,
    slidesToShow: 3,
    slidesToScroll: 1,
    arrows: false,
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 1,
          dots: true,
        },
      },
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          dots: true,
        },
      },
      {
        breakpoint: 560,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          dots: true,
        },
      },
    ],
    // beforeChange: (current, next) => {
    //   // show both arrows when middle
    //   if (next !== 0) {
    //     setIsFirstSlide(false);
    //     setIsFinalSlide(false);
    //   }

    //   // hide prev arrow when first slide
    //   if (next == 0) {
    //     setIsFirstSlide(true);
    //     setIsFinalSlide(false);
    //   }

    //   // hide next arrow when final slide
    //   if (next == townSliderImages.length - 1) {
    //     setIsFinalSlide(true);
    //   }
    // },
  };

  useEffect(() => {
    if (isSubmitted) {
      sliderCateRef.current.slickGoTo(0);
      dispatch(toggleSubmitted());
    }
  }, [isSubmitted]);

  return (
    <div>
      <h2 className="text-28 font-semibold mb-6 text-center leading-9">
        Step 1: Get to know the categories
      </h2>
      {/* grid md:grid-cols-3 gap-6  */}
      <div className="mb-10 md:mb-6 md:-mx-3">
        <Slider ref={sliderCateRef} {...settings}>
          {mainCategories?.map((category, index) => (
            <div key={index} className="md:px-3 h-full">
              <div
                key={category.id}
                className={`${categoryItems[index].background} h-full rounded-2xl px-7 pt-8 pb-12 md:py-8 text-white`}
              >
                <div className="mb-4 md:mb-8">
                  <img
                    className="w-1/2 md:w-full mx-auto"
                    src={category.image_url}
                    alt="image"
                  />
                </div>

                <div className="text-center md:text-left text-lg leading-6">
                  {category.description}
                </div>
              </div>
            </div>
          ))}
        </Slider>
      </div>

      <div className="text-center">
        <BtnGreen className="flex items-center" onClick={handleStepForm}>
          <span>Next</span>
          <span className="ml-16">
            <img src={require("@/assets/images/right-arrow.png")} alt="icon" />
          </span>
        </BtnGreen>
      </div>
    </div>
  );
};

Categories.propTypes = {};

export default Categories;
